import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { toast } from 'react-toastify';
import { labRequestReportAux } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_LABREQUESTREPORTAUX,
  DELETE_LABREQUESTREPORTAUX,
  GET_LABREQUESTREPORTAUXS,
  UPDATE_LABREQUESTREPORTAUX,
  UPDATE_LABREQUESTREPORTAUXCHECK
} from "./actionTypes";
import {
  addLabRequestReportAuxFail,
  addLabRequestReportAuxSuccess,
  deleteLabRequestReportAuxFail,
  deleteLabRequestReportAuxSuccess,
  getLabRequestReportAuxsFail,
  getLabRequestReportAuxsSuccess,
  setState,
  updateLabRequestReportAuxFail,
  updateLabRequestReportAuxSuccess,
  updateLabRequestSampleCheck,
} from "./actions";

//Include Both Helper File with needed methods

function* fetchLabRequestReportAuxs( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable,labRequestReportAux, params.toString());
    yield put(setState(false))
    yield put(getLabRequestReportAuxsSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestReportAuxsFail(error));
  }
}

function* updateLabRequestReportAux ({payload: labRequestReportAuxObj }) {
  try {
    const { id, recordStatus, ...rest } = labRequestReportAuxObj;
    yield call(patchApiCall, `${labRequestReportAux}/${id}`, rest);
    const response = yield call(getTable,`${labRequestReportAux}/${labRequestReportAuxObj.id}`);
    yield put(updateLabRequestReportAuxSuccess(response));
    toast.success('Registro actualizado correctamente')
  } catch (error) {
    yield put(updateLabRequestReportAuxFail(error));
    toast.error('Error al actualizar el registro')
  }
}

function* deleteLabRequestReportAux ({payload: labRequestReportAuxObj}) {
  try {
    yield call(deleteApiCall,`${labRequestReportAux}/${labRequestReportAuxObj.id}` );
    yield put(deleteLabRequestReportAuxSuccess(labRequestReportAuxObj.id));
    toast.success('Registro borrado correctamente')
  } catch (error) {
    yield put(deleteLabRequestReportAuxFail(error));
    toast.error('Error al borrar el registro')
  }
}

function* postingLabRequestReportAux ({ payload: labRequestReportAuxObj }) {
  try {
    const response = yield call(postApiCall, labRequestReportAux ,labRequestReportAuxObj);
    const response2 = yield call(getTable,`${labRequestReportAux}/${response.id}`);
    yield put(addLabRequestReportAuxSuccess(response2));
    toast.success('Registro agregado correctamente')
  } catch (error) {
    yield put(addLabRequestReportAuxFail(error));
    toast.error('Error al agregar el registro')
  }
}

function* labRequestReportAuxsSaga() {
  yield takeEvery(GET_LABREQUESTREPORTAUXS, fetchLabRequestReportAuxs);
  yield takeEvery(ADD_NEW_LABREQUESTREPORTAUX, postingLabRequestReportAux);
  yield takeEvery(UPDATE_LABREQUESTREPORTAUX, updateLabRequestReportAux);
  yield takeEvery(DELETE_LABREQUESTREPORTAUX, deleteLabRequestReportAux);
}

export default labRequestReportAuxsSaga;
